// extracted by mini-css-extract-plugin
export var centerText = "_cg-8";
export var container = "_cg-0";
export var doughnutContainer = "_cg-7";
export var legend = "_cg-a";
export var legendItemColorDisplay = "_cg-b";
export var legendItemLabel = "_cg-c";
export var lg = "_cg-5";
export var maxWidth = "_cg-9";
export var md = "_cg-4";
export var responsive = "_cg-6";
export var sm = "_cg-3";
export var xs = "_cg-2";
export var xxs = "_cg-1";